<div class="arrow_box bg-dark " *ngIf="bettingSlipStatus ">
  <span class="fa fa-chevron-up" style="font-size: 1.5rem" *ngIf="!bettingInfo"
    (click)="bettingInfo = !bettingInfo"></span>
  <span class="fa fa-chevron-down" style="font-size: 1.5rem" *ngIf="bettingInfo"
    (click)="bettingInfo = !bettingInfo"></span>
</div>


<div class="bet-slip-footer bg-dark" *ngIf="bettingSlipStatus && bettingInfo ">
  <app-your-betting-info [info]="cuponInfo" [raceDate]="raceDate" (clearAll)="clearBetSlip()"></app-your-betting-info>
</div>


<!-- In-page numeric keypad for the stake. Replaces the OS keyboard, which on a
     phone covers half the screen, hides the bet slip it is editing, and (below
     16px) used to zoom the whole page. -->
<div class="stake-keypad" *ngIf="keypadOpen && bettingSlipStatus" [@keypadSlide]>
  <div class="keypad-head">
    <span class="keypad-title">{{ "RACES.STAKES" | translate }}</span>
    <span class="keypad-value">{{ stakeDraft || '0' }} {{ authService.currentCurrency$ | async | uppercase }}</span>
  </div>
  <div class="keypad-grid">
    <button type="button" class="key" *ngFor="let k of keypadKeys" (click)="pressKey(k)">{{ k }}</button>
    <button type="button" class="key key-back" (click)="backspace()" aria-label="backspace">&#9003;</button>
  </div>
  <button type="button" class="keypad-done" (click)="closeKeypad()">
    {{ "RACES.KEYPAD_DONE" | translate }}
  </button>
</div>

<div class="stickyBar font-weight-normal my-3 bg-dark px-3 py-2" *ngIf="bettingSlipStatus">
  <div class="d-flex flex-column text-white w-full" *ngIf="bettingSlipStatus ">
    <!-- Bet Cart Price Info  -->
    <ng-container *ngIf="betService.allAddedBetsInCart$.value.length > 0">
      <ng-container *ngFor="let bet of allBetsOnCart$ | async">
        <div class="d-flex flex-row justify-content-between align-items-center border-bottom my-1 bet-line">
          <div>{{ bet?.selectedBet?.name | bettingType | translate | capitalizeFirst }}</div>
          <span class="bet-line-amount">{{ bet?.numberofBets }}&#215;
            {{ unitStake(bet?.selectedStake) | number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}}</span>
        </div>
      </ng-container>
    </ng-container>

    <div class="d-flex flex-row justify-content-between align-items-center border-bottom my-1 bet-line"
      *ngIf="this.betService.showCurrentBet$ | async">
      <div>{{ cuponInfo?.selectedBet?.name | bettingType | translate | capitalizeFirst }}</div>
      <span class="bet-line-amount">{{ betService.numberofBets }}&#215;
        {{ currentUnitStake() | number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}}</span>
    </div>

    <div class="d-flex flex-row justify-content-between align-items-center my-1 bet-total-line">
      <div>
        {{"Total" | translate}}
      </div>
      <span>{{ betService.totalAllBetsOnCart + betService.totalPrice | number: "1.2-2" }} {{authService.currentCurrency$
        | async | uppercase}}</span>
    </div>
    <!--  Bet Cart Price Info  -->
  </div>

  <div class="bet-actions text-white">
    <div class="stake-control">
      <form class="stake-stepper" [formGroup]="betService.raceDetailsForm">
        <button type="button" class="stepper-btn" (click)="decrease()"
          [attr.aria-label]="'RACES.STAKES' | translate">&#8722;</button>
        <!-- inputmode=decimal gives phones a number pad without <input type=number>
             spinners, and the 16px font in the stylesheet is what stops iOS Safari
             zooming the whole page in when the field is focused. -->
        <!-- The label sits INSIDE the field rather than beside it: one bordered
             box reading "Mise (TND) / 0.50" is a single object to the eye,
             where a separate floating label competed with the buttons for
             attention.
             On touch devices the field is readonly and opens the in-page keypad
             below: readonly is what reliably suppresses the OS keyboard on every
             iOS version, where inputmode="none" is only honoured on newer ones.
             Desktop keeps ordinary typing. -->
        <span class="stake-field">
          <span class="stake-caption">{{ "RACES.STAKES" | translate }}
            ({{ authService.currentCurrency$ | async | uppercase }})</span>
          <input class="stake-in stake-input" type="text"
          [attr.inputmode]="isTouchLayout ? 'none' : 'decimal'"
          [readonly]="isTouchLayout"
          [class.stake-red]="betService.raceDetailsForm.invalid === true"
          [class.stake-editing]="keypadOpen"
          (click)="toggleKeypad()"
          formControlName="selectedStake" [(ngModel)]="betService.selectedStake"
          appTwoDigitDecimaNumber />
        </span>
        <button type="button" class="stepper-btn" (click)="increase()"
          [attr.aria-label]="'RACES.STAKES' | translate">+</button>
      </form>
    </div>
    <button [disabled]="betService.numberofBets <= 0 || betService.placeBetSpinner || betService.raceDetailsForm.invalid"
      class="btn btn-warning place-bet-btn" (click)="showConfirmBetPopup()" [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--light':
          betService.placeBetSpinner
      }">
      <i *ngIf="betService.placeBetSpinner" class="pi pi-spin pi-spinner text-primary mr-2"
        style="font-size: 1.25rem"></i>
      {{ "RACES.PLACE_BET" | translate }}
    </button>
  </div>
</div>